import React, { useEffect, useState } from "react";
import MainContainer from "../../../layout/MainContainer";
import {
  Button,
  Card,
  Dialog,
  DialogContent,
  FormControl,
  IconButton,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import Box from "@mui/material/Box";
import SearchBar from "../../../components/SearchBar";
import { useNavigate, useParams } from "react-router-dom";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { isString, useFormik } from "formik";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import { isValidInput } from "../../../utils/validations";
import {
  useChangeCategoryStatusMutation,
  useLazyGetCategoriesQuery,
  useDeleteCategoryMutation,
} from "../../../services/main";
import { Loader, showError, showToast } from "../../../constants";
import { generateEncryptedKeyBody } from "../../../utils/crypto";
import { CommonBody } from "../../../types/General";
import WarnModal from "../../../components/WarnModal";
import Pagination from "../../../components/Pagination";
import useTranslation from "../../../hooks/Translation";
import { useLanguageContext } from "../../../context/Language";
import NoDataFound from "../../../components/NoDataFound";
import { resolveMediaUrl } from "../../../utils/mediaUrl";
import SkeletonTable from "../../../components/SkeletonTable";

const SubCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { language } = useLanguageContext() as any;
  const [updateCategory] = useChangeCategoryStatusMutation();
  const [deleteCategory] = useDeleteCategoryMutation();
  const [getCategories, { isLoading, isFetching, isSuccess }] = useLazyGetCategoriesQuery();
  const [value, setValue] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [category, setCategory] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<string>("");
  const [page, setPage] = useState(1);
  const translate=useTranslation();
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  let totalPages = Math.ceil(totalCount / 10);

  const getCategory = async () => {
    setLoading(true);
    try {
      const response = await getCategories({
        query: debouncedSearchTerm.trim(),
        page,
        type: 2,
        size: 10,
        categoryId: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        setCategory(response?.data?.category || []);
        setTotalCount(response?.data?.count);
      } else {
        setCategory([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory({ categoryId: id }).unwrap();
      if (response?.statusCode === 200) {
        showToast(translate?.error?.subCatDel || "");
        getCategory();
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const updateUserStatus = async (id: string, status: boolean) => {
    const data = {
      isBlocked: status,
    };

    let encryptedBody = generateEncryptedKeyBody(data) as CommonBody;

    const response = await updateCategory({
      encryptedBody,
      userId: id,
    }).unwrap();
    if (response?.statusCode === 200) {
      const updatedData = category.map((x: any) => {
        if (x._id === id) {
          return {
            ...x,
            isBlocked: status,
          };
        }
        return x;
      });
      setCategory(updatedData);
      showToast(translate?.error?.statusUpdate || "");
    } else {
      showError(translate?.error?.pleaseTryAgain || "");
    }
  };

  function createData(Name: string) {
    return { Name };
  }
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const rows = [createData("Grocery"), createData("Dining Out")];

  useEffect(() => {
    getCategory();
  }, [page, debouncedSearchTerm]);

  return (
    <MainContainer>
      <Loader isLoad={loading} isLinear />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng"> {translate?.main?.ManageSubCategory}</h1>
        </div>
        <Card className="cards">
          <Box className="custom_tabs">
            <Box className="cards_header">
              <SearchBar
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
              <Box className="cards_header_right">
                <Button
                  className="btn btn_primary"
                  onClick={() => navigate("/manage-categories")}
                >
                  {translate?.main?.Back}
                </Button>
              </Box>
            </Box>
            <TableContainer className="table_container">
              <Box className="heading"></Box>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"> {translate?.main?.SNo}</TableCell>
                    <TableCell> {translate?.main?.Image}</TableCell>
                    <TableCell> {translate?.main?.SubCategory}  {translate?.main?.Name}</TableCell>
                    <TableCell> {translate?.main?.Category}  {translate?.main?.Name}</TableCell>
                    <TableCell> {translate?.main?.Status}</TableCell>
                    <TableCell> {translate?.main?.Action}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <SkeletonTable columns={6} rows={10} />
                  ) : category?.length > 0 ? (
                    category?.map((row: any, i: any) => (
                      <TableRow key={row?._id}>
                        <TableCell align="center">
                          {(page - 1) * 10 + i + 1}
                        </TableCell>
                        <TableCell>
                          <figure className="user_img">
                            <img
                              src={
                                row?.image
                                  ? resolveMediaUrl(row?.image)
                                  : "/static/images/image_placeholder.jpeg"
                              }
                              alt=""
                            />
                          </figure>
                        </TableCell>
                        <TableCell>{(language === 'ar' ? row?.name_ar || row?.name : row?.name) || "-"}</TableCell>
                        <TableCell>{(language === 'ar' ? row?.parent?.name_ar || row?.parent?.name : row?.parent?.name) || "-"}</TableCell>
                        <TableCell>
                          <Switch
                            {...label}
                            size="small"
                            checked={!row?.isBlocked}
                            onChange={() =>
                              updateUserStatus(row?._id, !row?.isBlocked)
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Box className="table_actions">
                            <IconButton
                              onClick={() =>
                                navigate(`/manage-categories/edit/${row?._id}`)
                              }
                            >
                              <ModeEditIcon />
                            </IconButton>
                            <IconButton
                              onClick={() => {
                                setOpen(true);
                                setSelectedId(row?._id);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={9}>
                        <NoDataFound message={translate?.main?.NoSubcategoryFound} />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Card>
        {category?.length > 0 ? (
          <Pagination
            setPage={setPage}
            module={category}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </div>
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDelete(selectedId)}
        name="Sub-category"
      />
    </MainContainer>
  );
};

export default SubCategory;
